var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegisterCta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile-tick"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0332 16.3751L13.2999 17.6417L15.8332 15.1084",
    stroke: "#292D32",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1332 9.55829C10.0498 9.54996 9.94984 9.54996 9.85817 9.55829C7.87484 9.49163 6.29984 7.86663 6.29984 5.86663C6.2915 3.82496 7.94984 2.16663 9.9915 2.16663C12.0332 2.16663 13.6915 3.82496 13.6915 5.86663C13.6915 7.86663 12.1082 9.49163 10.1332 9.55829Z",
    stroke: "#292D32",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.99219 18.6751C8.47552 18.6751 6.96719 18.2917 5.81719 17.5251C3.80052 16.1751 3.80052 13.9751 5.81719 12.6334C8.10885 11.1001 11.8672 11.1001 14.1589 12.6334",
    stroke: "#292D32",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterCta);
export default __webpack_public_path__ + "static/media/registerCta.de10d15a9d30c24813c04e81d941fc6b.svg";
export { ForwardRef as ReactComponent };